module.exports = __webpack_public_path__ + "static/img/db.f5c4aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCenter/db.png
// module id = c9fU
// module chunks = 0